import { useCallback, useMemo } from 'react';

import { useCurrentEmployeeContext } from '@/common/contexts/CurrentEmployeeContext';
import { EmployeeRole, useGetCurrentEmployeePermissionAccessFlagNotificationLazyQuery } from '@/common/graphql';

export const useNotificationAccess = () => {
  const { currentEmployee, loading } = useCurrentEmployeeContext();
  const [loadNotification] = useGetCurrentEmployeePermissionAccessFlagNotificationLazyQuery();

  const hasNotificationCountryAccess = useMemo(
    () => currentEmployee?.permission?.role && [EmployeeRole.SuperAdmin].includes(currentEmployee.permission.role),
    [currentEmployee?.permission?.role],
  );

  const hasNotificationViewAccess = useMemo(
    () => currentEmployee?.accessFlag?.settingNotificationView ?? false,
    [currentEmployee?.accessFlag?.settingNotificationView],
  );

  const hasNotificationEditAccess = useCallback(
    async (companyId: string) => {
      const result = await loadNotification({
        variables: { companyId },
      });
      return result.data?.currentEmployee?.accessFlag?.settingNotificationEdit ?? false;
    },
    [loadNotification],
  );

  return {
    loading,
    hasNotificationCountryAccess,
    hasNotificationViewAccess,
    hasNotificationEditAccess,
    currentContractCompanyId: currentEmployee?.employee?.currentMainContract?.company.id,
    currentContractCompanyCountryId: currentEmployee?.employee?.currentMainContract?.company.countryId,
  };
};
